module.exports = __webpack_public_path__ + "static/media/canais-3.3c9a776e.jpg";